import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type FreeTextFilter,
  type MultiFilter,
} from '../types/filters';
import { titleDefinition, titleHandler } from './title';

export const multiTitleDefinition: FilterDefinition<
  MultiFilter<FreeTextFilter>
> = {
  id: FilterId.MULTI_TITLE,
  name: 'Titles',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.TITLE,
  instances: [],
  isVisible: true,
};

export const multiTitleHandler: FilterHandler<MultiFilter<FreeTextFilter>> = {
  isActive(currentFilterState: MultiFilter<FreeTextFilter>) {
    return currentFilterState.instances.some((instance) =>
      titleHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<FreeTextFilter>,
    _definition: FilterDefinition<MultiFilter<FreeTextFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<FreeTextFilter>,
    _definition: FilterDefinition<MultiFilter<FreeTextFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      titleHandler.getEffectiveFilter(instance, titleDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
